import React, { useEffect, useState } from 'react';
import { Card } from 'react-bootstrap';
import axiosInstance from '../../services/AxiosInstance';
import { groupBy } from '../../Functions/datasArrange';
import redCircle from '../../images/red_circle.png';
import { Link, useLocation } from 'react-router-dom';

const Notification = ({ role, uId }) => {

    const [notifications, setNotifications] = useState([]);
    const { pathname } = useLocation();

    useEffect(() => {
        getData();
        // eslint-disable-next-line
    }, []);

    const getData = () => {
        let filters = '';
        if (role === 1) filters = 'for_joc=true';
        if (role === 2 || role === 4) filters = `user=${uId}&for_joc=false`
        axiosInstance(`notification/?${filters}`, { method: "GET" })
            .then(res => {
                setNotifications(res?.data)
            })
            .catch(err => console.log('err in notifications: ', err))
    }

    const handleRead = (id) => {
        axiosInstance(`notification/${id}/`, { method: "PATCH", data: { "read": true } })
            .then(res => {
                if (res.status === 200) getData();
            })
    }

    const handleStatus = (url, field, status) => {
        axiosInstance(url, { method: "PATCH", data: { [field]: status } })
    }

    const handleReadAll = () => {
        axiosInstance('notification/bulk-read/', { method: "POST", data: notifications.map(a => a.id) })
            .then(res => {
                if (res.status === 200) getData();
            })
    }

    const handleClear = () => {
        axiosInstance(`notification/?delete_ids=${notifications.map(a => a.id)}`, { method: "DELETE" })
            .then(res => {
                if (res.status === 204) getData();
            })
    }

    return (
        <div className="btn-group dropleft">
            <span type="button" className="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {
                    notifications?.filter(notification => !notification.read)?.length > 0 &&
                    <Link to={"#"}>
                        <img
                            alt=""
                            src={redCircle}
                            width="10px"
                            style={{ borderRadius: "50%", marginTop: "-25px" }}
                        />
                    </Link>
                }
                <i className="fa fa-bell mr-3" title="Notifications" style={{ color: "#2e55fa", cursor: "pointer", fontSize: "1.5rem" }} />
            </span>
            <div className="dropdown-menu p-0" style={{ borderRadius: "10px" }}>
                {
                    notifications?.length > 0 ?
                        role === 1 ?
                            <>
                                {groupBy(notifications, 'n_type')?.profile?.length > 0 &&
                                    <>
                                        <span className="p-1 text-primary font-weight-bold">New Users Registered</span>
                                        {
                                            groupBy(notifications, 'n_type')?.profile?.slice(0, 3)?.map(res => {
                                                return (
                                                    <div className="d-flex bd-highlight"
                                                        style={{ backgroundColor: res?.read ? "white" : "#f3f4f9" }}
                                                        onClick={() => handleRead(res?.id)}>
                                                        <div className="p-2 flex-grow-1 bd-highlight ">
                                                            {
                                                                res?.link_to === pathname ?
                                                                    <span
                                                                        className="dropdown-item pl-3 pt-0 pb-0 hovcard cursor-pointer"
                                                                        style={{ fontSize: "16px" }}
                                                                    >
                                                                        {res?.message}
                                                                    </span>
                                                                    :
                                                                    <Link
                                                                        to={res?.link_to}
                                                                        className="dropdown-item pl-3 pt-0 pb-0 hovcard"
                                                                        style={{ fontSize: "16px" }}
                                                                    >
                                                                        {res?.message}
                                                                    </Link>
                                                            }
                                                        </div>
                                                        {
                                                            !res?.read &&
                                                            <>
                                                                <div className="p-2 bd-highlight cursor-pointer" onClick={() => handleStatus(`user/${res?.user}/`, 'joc_approve_status', 'a')}>
                                                                    <i className="fa fa-check" title="Click here to Approve" />
                                                                </div>
                                                                <div className="p-2 bd-highlight cursor-pointer" onClick={() => handleStatus(`user/${res?.user}/`, 'joc_approve_status', 'd')}>
                                                                    <i className="fa fa-ban" title="Click here to Deny" />
                                                                </div>
                                                            </>
                                                        }
                                                    </div>
                                                )
                                            }
                                            )
                                        }
                                        <hr className="m-0" />
                                    </>
                                }
                                {groupBy(notifications, 'n_type')?.job?.length > 0 &&
                                    <>
                                        <span className="p-1 text-primary font-weight-bold">New Jobs Posted</span>
                                        {
                                            groupBy(notifications, 'n_type')?.job?.slice(0, 3)?.map(res => {
                                                return (
                                                    <div className="d-flex bd-highlight"
                                                        style={{ backgroundColor: res?.read ? "white" : "#f3f4f9" }}
                                                        onClick={() => handleRead(res?.id)}
                                                    >
                                                        <div className="p-2 flex-grow-1 bd-highlight ">
                                                            <Link
                                                                to={res?.link_to}
                                                                className="dropdown-item pl-3 pt-0 pb-0 hovcard"
                                                                style={{ fontSize: "16px" }}
                                                            >
                                                                {res?.message}
                                                            </Link>
                                                        </div>
                                                        {
                                                            !res?.read &&
                                                            <>
                                                                <div className="p-2 bd-highlight cursor-pointer" onClick={() => handleStatus(`post-jobs/${res?.job}/`, 'job_status', 'a')}>
                                                                    <i className="fa fa-check" title="Click here to Approve" />
                                                                </div>
                                                            </>
                                                        }
                                                    </div>
                                                )
                                            })
                                        }
                                    </>
                                }
                            </>
                            :
                            notifications?.map(item => {
                                return (
                                    <>
                                        <Card key={item?.id} style={{ borderRadius: "0" }} onClick={() => handleRead(item?.id)}>
                                            <Link
                                                to="#"
                                                className="dropdown-item pl-3 pt-0 pb-0 hovcard"
                                                style={{ fontSize: "16px" }}
                                            >
                                                {item.message}
                                            </Link>
                                        </Card>
                                    </>
                                )
                            })
                        :
                        <span className="p-2">No New Notification</span>
                }
                <div className="d-flex justify-content-between ml-2 mr-2">
                    {
                        notifications?.length > 0 &&
                        <span className="cursor-pointer" onClick={() => handleClear()}>Clear</span>
                    }
                    {
                        notifications?.length > 0 && notifications.filter(n => n.read === false).length > 0 &&
                        <span className="cursor-pointer" onClick={() => handleReadAll()}>Mark all as read</span>
                    }
                    {
                        (notifications?.filter(n => n.read === false)?.length > 3 || notifications?.length > 6) &&
                        <Link to="notifications">View All</Link>
                    }
                </div>
            </div>
        </div>
    );
};

export default Notification;